import React from 'react';
import { Container } from '@mui/material';

function QDeliveryTokenPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      Qdelivery
    </Container>
  );
}

export default QDeliveryTokenPage;
